import { TextVariants } from '@lichtblick/theme';
import { ApprovalState, GetWorkGroup_V1Query } from '@lichtblick/types';

import { Top, WorkgroupCardContainer } from './WorkgroupCard.styles';

import { Chip } from '../Chip';
import { TaskProgressBar } from '../TaskProgressBar';
import { Text } from '../Text';

type Counter = { count: number; link?: string };

export type WorkgroupCardProps = {
  isHighlighted?: boolean;
  onBarClick: (itemId: string) => void;
  onChipClick: (link: string) => void;
  status: {
    counter?: Counter;
    type: ApprovalState;
  };
  title: string;
  workGroupId: number;
  workItems: NonNullable<GetWorkGroup_V1Query['getWorkGroup_V1']['data']>['items'];
};

export const WorkgroupCard = ({
  isHighlighted,
  onBarClick,
  onChipClick,
  status,
  title,
  workGroupId,
  workItems,
}: WorkgroupCardProps) => {
  return (
    <WorkgroupCardContainer
      $isHighlighted={isHighlighted}
      data-testid="workgroup-card"
      id={`workgroup-${workGroupId}`}
      onClick={() => (workItems?.[0]?.id ? onBarClick(workItems[0].id) : {})}
    >
      <Top>
        <Text $variant={TextVariants.title.m}>{title}</Text>
        {status && <Chip counter={status.counter} onClick={onChipClick} size={'small'} variant={status.type} />}
      </Top>
      {workItems && <TaskProgressBar onBarClick={(itemId: string) => onBarClick(itemId)} workItems={workItems} />}
    </WorkgroupCardContainer>
  );
};
